import { initializeApp } from "firebase/app"
import { getFirestore, onSnapshot, doc } from "firebase/firestore"
import { collection, query, where, getDocs } from "firebase/firestore"

const firebaseConfig = {
  databaseURL: "https://grounded-map-default-rtdb.europe-west1.firebasedatabase.app",
  apiKey: "AIzaSyBEE7plzmWu6-V5JVPWZ3apgfUeB3Ob9WA",
  authDomain: "grounded-map.firebaseapp.com",
  projectId: "grounded-map",
  storageBucket: "grounded-map.appspot.com",
  messagingSenderId: "899654737781",
  appId: "1:899654737781:web:79bec3bd4ed8e7912f3d3c"
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)

import { getAuth } from "firebase/auth"

export const auth = getAuth()
export {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  onAuthStateChanged,
  signOut as signOutAuth
} from "firebase/auth"
import { getDatabase, ref, child, push, update } from "firebase/database";

export const get = async (ref, opt = []) => {
  if (opt && opt.length) {
    const q = query(collection(db, ref), where(opt[0], opt[1], opt[2]))
    return getDocs(q)
  } else {
    const q = query(collection(db, ref))
    return getDocs(q)
  }
}

export const on = (path, id, callback) => {
  return onSnapshot(doc(db, `${path}/${id}`), docRef => {
    return callback ? callback(docRef.data()) : docRef.data()
  })
}


export const write = (_path, data) => {
  const [path, id] = _path.split('/')
  const db = getDatabase();
  const key = id || push(child(ref(db), path)).key;
  const updates = {
    [`/${path}/${key}`]: data
  }
  return update(ref(db), updates);
}
